var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99984 1.83329C5.31794 1.83329 2.33317 4.81806 2.33317 8.49996C2.33317 12.1819 5.31794 15.1666 8.99984 15.1666C12.6817 15.1666 15.6665 12.1819 15.6665 8.49996C15.6665 4.81806 12.6817 1.83329 8.99984 1.83329ZM0.666504 8.49996C0.666504 3.89759 4.39746 0.166626 8.99984 0.166626C13.6022 0.166626 17.3332 3.89759 17.3332 8.49996C17.3332 13.1023 13.6022 16.8333 8.99984 16.8333C4.39746 16.8333 0.666504 13.1023 0.666504 8.49996ZM8.99984 4.33329C9.46008 4.33329 9.83317 4.70639 9.83317 5.16663V8.49996C9.83317 8.9602 9.46008 9.33329 8.99984 9.33329C8.5396 9.33329 8.1665 8.9602 8.1665 8.49996V5.16663C8.1665 4.70639 8.5396 4.33329 8.99984 4.33329ZM8.1665 11.8333C8.1665 11.3731 8.5396 11 8.99984 11H9.00817C9.46841 11 9.8415 11.3731 9.8415 11.8333C9.8415 12.2935 9.46841 12.6666 9.00817 12.6666H8.99984C8.5396 12.6666 8.1665 12.2935 8.1665 11.8333Z",
    fill: "#087F5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.101c2072d2feb8929c6cc66e737a9cfa.svg";
export { ForwardRef as ReactComponent };